import { render } from "./appearance.vue?vue&type=template&id=19c601fc"
import script from "./appearance.vue?vue&type=script&lang=js"
export * from "./appearance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__